/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import {
  Card, Typography, Grid, TextField, IconButton, Snackbar,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import DoneIcon from '@material-ui/icons/Done';
import Alert from '@material-ui/lab/Alert';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import userActions from '../../../redux/actions/userActions';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
  },
  cardHeader: {
    backgroundColor: theme.palette.primary.main,
    color: '#FFF',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
  cardBody: {
    padding: theme.spacing(2),
  },
  input: {
    width: '80%',
  },
}));

const ProfileEditWidget = ({
  firstname, lastname, email, _id, updateUserNames,
}) => {
  const classes = useStyles();
  const [snackbar, setSnackbar] = useState({ open: false, severity: 'success', message: '' });

  const [values, setValues] = useState({
    firstname,
    lastname,
    editFirstname: true,
    editLastname: true,
  });

  const forbiddenCharacter = /^[\p{L}'][ \p{L}'-]*[\p{L}]$/u;

  const updateStudent = (prop) => {
    const body = {};

    if (prop === 'editFirstname') {
      // eslint-disable-next-line max-len
      body.firstname = values.firstname.charAt(0).toUpperCase() + values.firstname.slice(1).toLowerCase();
    } else if (prop === 'editLastname') {
      body.name = values.lastname.toUpperCase();
    }

    const isValid = (body.firstname && forbiddenCharacter.test(body.firstname))
      || (body.name && forbiddenCharacter.test(body.name));

    if (isValid) {
      updateUserNames(_id, body);
      setSnackbar({ open: true, severity: 'success', message: 'Name successfully changed' });
    } else {
      setSnackbar({ open: true, severity: 'error', message: 'Certain symbols and numbers are forbidden' });
    }
  };

  const handleEdit = (prop) => () => {
    const wasEditing = values[prop];

    setValues((prev) => ({
      ...prev,
      [prop]: !prev[prop],
      firstname: prev.firstname.charAt(0).toUpperCase() + prev.firstname.slice(1).toLowerCase(),
      lastname: prev.lastname.toUpperCase(),
    }));

    if (wasEditing && (values.firstname !== firstname || values.lastname !== lastname)) {
      updateStudent(prop);
    }
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleCloseSnackbar = (_, reason) => {
    if (reason !== 'clickaway') setSnackbar({ ...snackbar, open: false });
  };

  const ariaLabelFirstname = values.editFirstname ? 'Edit firstname' : 'Save firstname';
  const ariaLabelLastname = values.editLastname ? 'Edit lastname' : 'Save lastname';

  return (
    <Card>
      <Snackbar
        role="alert"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} variant="outlined" severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Grid container className={classes.root}>
        <Grid item xs={12} className={classes.cardHeader}>
          <Typography component="h3" variant="h6">Your personal information</Typography>
        </Grid>

        <Grid container spacing={2} className={classes.cardBody}>
          <Grid item xs={12}>
            <TextField
              id="firstname"
              className={classes.input}
              label="Firstname"
              onChange={handleChange('firstname')}
              value={values.firstname}
              disabled={!values.editFirstname}
            />
            <IconButton
              aria-label={ariaLabelFirstname}
              aria-live="polite"
              onClick={handleEdit('editFirstname')}
              title={ariaLabelFirstname}
            >
              {values.editFirstname ? <EditIcon /> : <DoneIcon />}
            </IconButton>
          </Grid>

          <Grid item xs={12}>
            <TextField
              id="lastname"
              className={classes.input}
              label="Lastname"
              onChange={handleChange('lastname')}
              value={values.lastname}
              disabled={!values.editLastname}
            />
            <IconButton
              aria-label={ariaLabelLastname}
              onClick={handleEdit('editLastname')}
              title={ariaLabelLastname}
            >
              {values.editLastname ? <EditIcon /> : <DoneIcon />}
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

ProfileEditWidget.propTypes = {
  firstname: PropTypes.string.isRequired,
  lastname: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  _id: PropTypes.string.isRequired,
  updateUserNames: PropTypes.func.isRequired,
};

const mapState = (state) => {
  const { firstname, name: lastname, email } = state.user.userData;
  const { _id } = state.auth.authData;
  return {
    _id, firstname, lastname, email,
  };
};

const actionCreators = {
  updateUserNames: userActions.updateUserNames,
};

export default connect(mapState, actionCreators)(ProfileEditWidget);
